import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["color", "size", "children", "title", "titleId"];
import React, { useId, createRef } from 'react';
import { styled } from '@grupoboticario/flora-react-system';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var getSize = size => typeof size === 'number' || /^\d+$/.test(size) ? size + "px" : size;
var SvgStyled = styled('svg', {});
export var Icon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      color = 'currentColor',
      size = 24,
      children,
      title,
      titleId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var sizeValue = getSize(size);
  var generatedId = useId();
  var finalTitleId = titleId || generatedId;
  return /*#__PURE__*/_jsxs(SvgStyled, _extends({}, props, {
    ref: ref || /*#__PURE__*/createRef()
  }, title && {
    'aria-labelledby': finalTitleId,
    role: 'img'
  }, {
    "aria-hidden": title ? undefined : true,
    css: _extends({
      fill: color,
      width: sizeValue,
      height: sizeValue
    }, props.css || {}),
    children: [title && /*#__PURE__*/_jsx("title", {
      id: finalTitleId,
      children: title
    }), children]
  }));
});
//# sourceMappingURL=Icon.js.map